var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pie-chart',{attrs:{"chart-data":_vm.chartData,"chart-id":"current-alert-pie-chart","colors":_vm.colors,"height":190,"legendPosition":"right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }